import React from 'react';
import { Building } from 'lucide-react';

/**
 * Le nom d'un site, en badge.
 *
 * Il en existait deux copies — une pour les transferts de personnel, une pour
 * ceux d'élèves — et corriger l'une laissait l'autre en l'état. C'est la même
 * duplication que celle du modal : une seule définition, partagée.
 *
 * Largeur fixe, comme le veut le modèle visuel pour tout badge répété d'une
 * ligne à l'autre. Sans elle, chaque étiquette se calait sur la longueur de son
 * texte ; le suffixe « (actuel) » changeant de côté selon le sens du transfert,
 * la flèche et le site d'arrivée sautaient d'une ligne sur l'autre.
 *
 * Un nom d'école plus long se coupe proprement plutôt que de faire déborder le
 * badge ; le nom complet reste accessible au survol.
 */
const SiteTag = ({ name, isCurrent = false }) => {
  const libelle = name || 'Site non renseigné';
  return (
    <span
      title={`${libelle}${isCurrent ? ' (site actuel)' : ''}`}
      className={`inline-flex items-center justify-center gap-1 w-[132px] h-6 px-2 rounded-md text-xs font-medium whitespace-nowrap ${
        isCurrent
          ? 'bg-[#246990]/10 text-[#246990] ring-1 ring-[#246990]/20'
          : 'bg-gray-100 text-gray-600'
      }`}
    >
      <Building size={10} className="flex-shrink-0" />
      <span className="truncate">{libelle}</span>
      {isCurrent && <span className="text-[11px] flex-shrink-0">(actuel)</span>}
    </span>
  );
};

export default SiteTag;
